module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "corn"
  }, [_vm._v("•    •    •    •    •")]), _vm._v(" "), _c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "href": "#/f007"
    }
  }, [_vm._v("Prologue: Awash in Red")])]), _vm._v(" "), _c('p', {
    staticClass: "ctpn"
  }, [_c('a', {
    attrs: {
      "href": "#/f008"
    }
  }, [_vm._v("PART ONE: BIRTH OF A BOOTLEGGER")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('a', {
    attrs: {
      "href": "#/f009"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("1")]), _vm._v(" Napoleon of the Bar")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('a', {
    attrs: {
      "href": "#/f010"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("2")]), _vm._v(" Illicit Relations")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("3")]), _vm._v(" Birth of a Bootlegger")])]), _vm._v(" "), _c('p', {
    staticClass: "ctpn"
  }, [_c('span', {
    attrs: {
      "href": "#/f012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO: KING OF THE BOOTLEGGERS")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("4")]), _vm._v(" The Bourbon Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("5")]), _vm._v(" Underworld Boss of Death Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("6")]), _vm._v(" Every Man Has His Price")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("7")]), _vm._v(" Epic Grandeur")])]), _vm._v(" "), _c('p', {
    staticClass: "ctpn"
  }, [_c('span', {
    attrs: {
      "href": "#/f017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE: PLUNDERING AN EMPIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("8")]), _vm._v(" Ace Bags the King")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("9")]), _vm._v(" Business as Usual")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("10")]), _vm._v(" Life in Hell")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("11")]), _vm._v(" Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("12")]), _vm._v(" Heavy Lover")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("13")]), _vm._v(" Plundering the Bourbon Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "ctpn"
  }, [_c('span', {
    attrs: {
      "href": "#/f024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR: A VERY DANGEROUS MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("14")]), _vm._v(" A Shot Rings Out")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("15")]), _vm._v(" “Ready for the Battle—It’s a Fight!”")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("16")]), _vm._v(" Cutthroats and Assassins")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("17")]), _vm._v(" Let’s Give Him a Nice Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "ctpn"
  }, [_c('span', {
    attrs: {
      "href": "#/f029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FIVE: LOST MILLIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f030",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("18")]), _vm._v(" Rise of the Gangster")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f031",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("19")]), _vm._v(" Dodge’s Demise")])]), _vm._v(" "), _c('p', {
    staticClass: "ctct"
  }, [_c('span', {
    attrs: {
      "href": "#/f032",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ccn"
  }, [_vm._v("20")]), _vm._v(" Remus v. Prohibition")])]), _vm._v(" "), _c('p', {
    staticClass: "ctbm"
  }, [_c('span', {
    attrs: {
      "href": "#/f033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Fall of the Bootleg Baron")])]), _vm._v(" "), _c('p', {
    staticClass: "ctfm"
  }, [_c('span', {
    attrs: {
      "href": "#/f034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "ctfm"
  }, [_c('span', {
    attrs: {
      "href": "#/f039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da70a036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f006.vue
// module id = 75
// module chunks = 0